import { apiClient } from '@/utils/axios'
import { dateToString } from '@/utils/date-converter.ts'

import { UseAutoFollowTableProps } from '../hooks/use-auto-follow-table'
import type {
  AutoFollowFailedFansResponse,
  AutoFollowFollowedFansResponse,
  AutoFollowQueuedFansResponse,
} from '../types'

type QueryParameters = Omit<UseAutoFollowTableProps, 'key'>

export const getQueuedAutoFollows = async ({
  dateRange,
  creatorId,
  page,
  size,
}: QueryParameters) => {
  const response = await apiClient.get<AutoFollowQueuedFansResponse>(
    `/creator/${creatorId}/fan/follow/queued`,
    {
      params: {
        from: dateToString(dateRange?.from),
        to: dateToString(dateRange?.to),
        page,
        limit: size,
      },
    },
  )

  return response.data
}

export const getFailedAutoFollows = async ({
  dateRange,
  creatorId,
  page,
  size,
}: QueryParameters) => {
  const response = await apiClient.get<AutoFollowFailedFansResponse>(
    `/creator/${creatorId}/fan/follow/failed`,
    {
      params: {
        from: dateToString(dateRange?.from),
        to: dateToString(dateRange?.to),
        page,
        limit: size,
      },
    },
  )

  return response.data
}

export const getFollowedAutoFollows = async ({
  dateRange,
  creatorId,
  page,
  size,
}: QueryParameters) => {
  const response = await apiClient.get<AutoFollowFollowedFansResponse>(
    `/creator/${creatorId}/fan/follow/followed`,
    {
      params: {
        from: dateToString(dateRange?.from),
        to: dateToString(dateRange?.to),
        page,
        limit: size,
      },
    },
  )

  return response.data
}

export const getAutoFollowCaption = async ({
  dateRange,
  creatorId,
}: Omit<UseAutoFollowTableProps, 'page' | 'size' | 'key'>) => {
  const queryParameters = {
    dateRange,
    creatorId,
    page: 1,
    size: 1,
  }
  const followedFans = await getFollowedAutoFollows(queryParameters)
  const queuedFans = await getQueuedAutoFollows(queryParameters)
  const failedFans = await getFailedAutoFollows(queryParameters)

  return {
    followed: followedFans.total,
    queued: queuedFans.total,
    failed: failedFans.total,
  }
}
